module.exports = __webpack_public_path__ + "img/2.3640d1b9.jpg";